import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  // Sizing,
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  getSize,
  //   hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const Careers = () => (
  <Section
    css={`
      margin-bottom: 0px;
    `}
  >
    <StaticQuery
      query={graphql`
        query CareersCareersHeroImageQuery {
          file(relativePath: { eq: "workshop_desk.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="Two engineers working with electronics on a table"
          css={`
            + picture > img,
            img {
              object-position: 0% 0%;
            }
          `}
          file={file}
        />
      )}
    />

    <Card>
      <Header2>
        {"Careers"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 20px;
          }
        `}
      >
        {
          "Savant Power is growing. We’re looking for exceptional people to join our team."
        }
      </Paragraph>
    </Card>
  </Section>
);

Careers.propTypes = {};
